import {envLoader} from "../env/envLoader";
import axios from "axios";

const baseUrl = envLoader().base_url;

export const log = async (message, typeLog) => {
    const data = {message, type:typeLog, date: new Date()};
    return await axios.post(`${baseUrl}log/log`, data).then(res => res.data.data);
}
